import React from "react";
import { ReactDataGrid } from "rhombus-react";
const { Row } = ReactDataGrid;


export default function SelectedRow(props){
	return <Row {...props} extraClasses={props.row.isDisabled ? "is-disabled" : ""} isSelected={props.row.isSelected} />;
}
